import { TFileWithMeta } from '@components/FileUpload/components/dropzone/types/TFileWithMeta';
import { handleDownloadError, triggerBrowserDownload } from '@helpers/jobLinkHelpers';
import { UploadObjectType } from 'app/types/enums/uploadObjectType';
import { client } from 'app/http';

export async function getDownloadLink(Id = '', objectType: UploadObjectType, fileWithMeta: TFileWithMeta) {
  if (objectType !== UploadObjectType.REPOSITORY || !fileWithMeta.meta.Id) {
    return;
  }

  try {
    const response = await client.get(`repositories/attachments/${Id}/download`, {
      params: { disposition: 'attachment' },
    });

    const url = response.data?.url;
    if (!url) {
      throw new Error('Download URL missing');
    }

    triggerBrowserDownload(url, fileWithMeta.meta.name);
  } catch (error) {
    handleDownloadError(error);
  }
}
